import * as React from "react";

const LessonBadge = ({ level, unit }) => {
    return (
        <div className="flex flex-col self-stretch my-auto w-36 text-base font-semibold text-center rounded-[50px] text-zinc-600">
            <div className="flex justify-center items-center px-3 border border-solid border-zinc-300 min-h-[34px] rounded-[50px]">
                <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/36169627af929c03b078787051d2a44acdb41dcb94aead00a2087a25f4b3c9f5?placeholderIfAbsent=true&apiKey=c60c5915f79342b5a881a41f485aed95"
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
                />
                <div className="gap-2 self-stretch my-auto w-[102px]">
                    {level}레벨 {unit}단원
                </div>
            </div>
        </div>
    );
}

export default LessonBadge;